import { Nomenclature } from './Nomenclature';
import { FrxBaseBean } from './frxbasebean';
import { StatusBean } from './StatusBean';

export class Instance extends FrxBaseBean {
	dataNasrochen;
	lawsuiteId: number;
	'number': string;
	note: string;
	archiveFolderName: string;
	timeNasrochen: string;

	instance: Nomenclature;
	city: Nomenclature;
	court: Nomenclature;
	status: StatusBean;

	glavnica: number;
	glavnicaImushtestv: number;
	lihvaDate;
	lihvaImushtestvDate;
	prisudeniRaznoski: string;
	raznoskiOtvetnaStrana: number;

	sudiaDokladchik: string;
	suprichinjavane?: string;
	prietaSuma?: number;

	summonReceivedDate?: string; // yyyy-MM-dd от input[type=date]
	summonTermDays?: number;
	zadachaDeadline?;

	copy(source: Instance) {
		super.copy(source);
		this.number = source.number;
		this.instance = source.instance;
		this.city = source.city;
		this.court = source.court;
		this.note = source.note;

		this.glavnica = source.glavnica;
		this.glavnicaImushtestv = source.glavnicaImushtestv;
		this.lihvaDate = source.lihvaDate;
		this.lihvaImushtestvDate = source.lihvaImushtestvDate;
		this.prisudeniRaznoski = source.prisudeniRaznoski;
		this.raznoskiOtvetnaStrana = source.raznoskiOtvetnaStrana;

		this.sudiaDokladchik = source.sudiaDokladchik;
		this.suprichinjavane = source.suprichinjavane;
		this.prietaSuma = source.prietaSuma;

		this.status = source.status
			? Object.assign(new StatusBean(), source.status)
			: null;

		this.summonReceivedDate = source.summonReceivedDate;
		this.summonTermDays = source.summonTermDays;
		this.zadachaDeadline = source.zadachaDeadline;
	}
}
